import { render, staticRenderFns } from "./FilesDetail.vue?vue&type=template&id=c44e3a3e&"
import script from "./FilesDetail.vue?vue&type=script&lang=js&"
export * from "./FilesDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports